import { slug } from '@magalu/mixer-utils';
var getContent = function getContent(content, type) {
  var actions = {
    "default": function _default() {
      return slug(content || '') || null;
    },
    error: function error() {
      return "error:".concat(slug(content) || null);
    }
  };
  var action = actions[type] || actions["default"];
  return action();
};
var viewContentHeader = function viewContentHeader(content, type) {
  return {
    content_id: getContent(content, type),
    content_type: 'menu-superior',
    event: 'view_content'
  };
};
export default viewContentHeader;